<div class="change-detail-dialog">
    <header class="dialog-header">
        <h2 class="dialog-title">{{ titleKey | translate }}</h2>
        <div class="dialog-meta">
            {{ 'i18n_af_history_meta_dateTime' | translate }}: {{ data.entry.datetime | date: 'dd.MM.yyyy HH:mm:ss' }},
            {{ 'i18n_af_history_meta_author' | translate }}: {{ data.entry.author || '—' }}<ng-container *ngIf="data.entry.userType">,
                {{ ('i18n_af_incidentHistoryAddedBy#' + data.entry.userType) | translate }}
            </ng-container>
        </div>
    </header>

    <div class="dialog-body" *ngIf="ready">
        <ng-container *ngIf="eventType !== 'UPDATED'">
            <div class="empty" *ngIf="groups.length === 0">
                {{ 'i18n_af_history_no_snapshot' | translate }}
            </div>
            <div class="info-card" *ngIf="groups.length > 0">
                <section class="field-group" *ngFor="let group of groups">
                    <h3 class="group-title">{{ group.titleKey | translate }}</h3>
                    <dl class="field-list">
                        <ng-container *ngFor="let row of group.rows">
                            <dt class="field-label">{{ row.label }}</dt>
                            <dd class="field-value">
                                <a *ngIf="row.navigationTarget" class="underlined-text c-primary-green-800 pointer"
                                   (click)="navigateTo(row.navigationTarget)">{{ row.value }}</a>
                                <ng-container *ngIf="!row.navigationTarget">{{ row.value }}</ng-container>
                            </dd>
                        </ng-container>
                    </dl>
                </section>
            </div>
        </ng-container>

        <ng-container *ngIf="eventType === 'UPDATED'">
            <div class="empty" *ngIf="changedFields.length === 0">
                {{ 'i18n_af_history_no_changes' | translate }}
            </div>
            <div class="diff-panels" *ngIf="changedFields.length > 0">
                <section class="pane pane-before">
                    <h3 class="pane-title">{{ 'i18n_af_history_col_before' | translate }}</h3>
                    <dl class="field-list">
                        <ng-container *ngFor="let row of changedFields">
                            <dt class="field-label">{{ row.label }}</dt>
                            <dd class="field-value">{{ row.oldValue }}</dd>
                        </ng-container>
                    </dl>
                </section>
                <section class="pane pane-after">
                    <h3 class="pane-title">{{ 'i18n_af_history_col_after' | translate }}</h3>
                    <dl class="field-list">
                        <ng-container *ngFor="let row of changedFields">
                            <dt class="field-label">{{ row.label }}</dt>
                            <dd class="field-value">{{ row.newValue }}</dd>
                        </ng-container>
                    </dl>
                </section>
            </div>
        </ng-container>
    </div>
</div>
